var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CentralModalFrame"},[_c('div',{staticClass:"CentralModalFrame__content animated fadeIn"},[_vm._t("modal")],2),_vm._v(" "),_c('div',{staticClass:"CentralModalFrame__overlay",on:{"click":_vm.closeModal}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-486311c4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Help/CentralModalFrame/index.vue
// module id = 1219
// module chunks = 0 2